import React from 'react';
import styled, { keyframes } from 'styled-components';

import LoadingIcon from '../../icons/loading.svg';

const Loading = () => (
  <Wrapper>
    <StyledLoadingIcon />
  </Wrapper>
);

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  } 
  to {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.div`
  text-align: center;
  padding: 20px;
`;

const StyledLoadingIcon = styled(LoadingIcon)`
  animation: ${rotate} 0.5s linear infinite;
  path {
    fill: rgb(96, 98, 109);
  }
`;

export default Loading;
